import Index from '../components/VideoOrder/Index';

let routes = {
    path: '/videoOrder',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/videoOrder',
            component: Index
        }
    ]
};

export default routes;


// WEBPACK FOOTER //
// ./src/router/videoOrder.js